import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M9.926 1.277h-5.1a2.678 2.678 0 0 0-2.68 2.67v8.18a2.678 2.678 0 0 0 2.68 2.67h6.35a2.678 2.678 0 0 0 2.68-2.67V5.2Zm2.43 10.85a1.18 1.18 0 0 1-1.18 1.17H6.5v-.8H5v.8h-.17a1.18 1.18 0 0 1-1.18-1.17v-8.18a1.18 1.18 0 0 1 1.18-1.17H6.5V3.5H8v-.72h1.25v3.11h3.11ZM5 3.5h1.5V5H5ZM6.5 5H8v1.5H6.5ZM5 6.5h1.5V8H5ZM6.5 8H8v1.5H6.5ZM5 9.5h1.5V11H5ZM6.5 11H8v1.5H6.5Z';
const draw24px = 'M14.936,1.889H7.056a3.751,3.751,0,0,0-3.75,3.75v12.73a3.758,3.758,0,0,0,3.75,3.75h9.89a3.758,3.758,0,0,0,3.75-3.75V7.639Zm4.26,16.48a2.253,2.253,0,0,1-2.25,2.25H7.056a2.247,2.247,0,0,1-2.25-2.25V5.639a2.241,2.241,0,0,1,2.25-2.25h6.88v5.25H19.2ZM8,3.75H9.5v1.5H8ZM6.5,5.25H8v1.5H6.5ZM8,6.75H9.5v1.5H8ZM6.5,8.25H8v1.5H6.5ZM8,9.75H9.5v1.5H8Zm-1.5,1.5H8v1.5H6.5ZM8,12.75H9.5v1.5H8Zm-1.5,1.5H8v1.5H6.5ZM8,15.75H9.5v1.5H8Zm-1.5,1.5H8v1.5H6.5ZM8,18.75H9.5v1.5H8Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const DocumentZipIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'documentZip'));
DocumentZipIcon.displayName = 'DocumentZipIcon';
DocumentZipIcon.propTypes = Icon.propTypes;
DocumentZipIcon.renderIcon = props => /*#__PURE__*/React.createElement(DocumentZipIcon, props);
export default DocumentZipIcon;
//# sourceMappingURL=DocumentZipIcon.js.map